import PropTypes from 'prop-types';


export function estimatedHours(startTime, endTime, nearestHalf = false) {
  const hours = ((endTime - startTime) / 1000 / 60 / 60);
  return (nearestHalf) ? Math.round(hours * 2) / 2 : Math.round(hours);
}


export function getMappedStatusText(shift) {
  switch (shift.status) {
    case 'LOOKING_FOR_PROS':
      return `Looking for ${(shift.required_pros > 1) ? 'Pros' : 'Pro'}`;
    case 'PROS_FOUND':
      return `${(shift.required_pros > 1) ? 'Pros' : 'Pro'} Found`;
    case 'COMPLETED':
      return 'Completed';
    case 'NO_PROS_FOUND':
      return 'No Pros Found';
    case 'CANCELLED':
      return 'Cancelled';
    default:
      return shift.status.charAt(0) + shift.status.slice(1).toLowerCase();
  }
}


export function getUTMCodes() {
  const url = new URL(window.location.href);
  return {
    "utm_source": url.searchParams.get("utm_source"),
    "utm_medium": url.searchParams.get("utm_medium"),
    "utm_campaign": url.searchParams.get("utm_campaign"),
    "utm_term": url.searchParams.get("utm_term"),
    "utm_content": url.searchParams.get("utm_content"),
  };
}

export function placeParams(pathRegex, params) {
  const segments = pathRegex.split("/");
  return segments.map(segment => {
    const offset = segment.indexOf(":") + 1;
    if (!offset)
      return segment;

    const key = segment.slice(offset);
    return params[key];
  }).join("/");
}




// WEBPACK FOOTER //
// ./src/utilities.js